// extracted by mini-css-extract-plugin
export default {"buyMeACoffeeLink":"BuyMeACoffeeLink_buyMeACoffeeLink__jhZNX","icon":"BuyMeACoffeeLink_icon__8ZrRg","text":"BuyMeACoffeeLink_text__6LPDQ"};